export const strings = {
    suffixAgo: 'önce',
    suffixFromNow: null,
    seconds: '1 dakikadan',
    minute: '1 dakika',
    minutes: '%d dakika',
    hour: '1 saat',
    hours: '%d saat',
    day: '1 gün',
    days: '%d gün',
    month: '1 ay',
    months: '%d ay',
    year: '1 yıl',
    years: '%d yıl',
};
